import React from 'react'
import classnames from '@helpers/misc/classnames'
import useIsDarkMode from '@hooks/useIsDarkMode'
import useScreenSize from '@hooks/useScreenSize'

export default function ReservationsCheckoutCard({
  children,
  className = '',
  mobileStyle = 'default',
  transparentOnDesktop = false,
  id
}: {
  children: React.ReactNode
  className?: string
  mobileStyle?: 'default' | 'compact'
  transparentOnDesktop?: boolean
  id?: string
}) {
  const screenSize = useScreenSize()
  const isMobile = screenSize === 'mobile' || screenSize === 'sm'
  const isDarkMode = useIsDarkMode()

  if (transparentOnDesktop && !isMobile) {
    return <div className={className}>{children}</div>
  }

  return (
    <section
      id={id}
      className={classnames({
        'relative py-4 px-1 md:px-2 shadow-sm md:shadow md:rounded-lg mb-3 md:mb-8 last:mb-0 w-full':
          true,
        [className]: true,
        'mb-0 shadow-none border-b-0': mobileStyle === 'compact' && isMobile,
        'bg-white border-gray-200 shadow-gray-200': !isDarkMode,
        'bg-gray-800 border-gray-400 shadow-gray-400': isDarkMode
      })}>
      <div className="px-3 py-2">{children}</div>
    </section>
  )
}
